import React, { useState } from 'react';
import Header from './Header';
import TestimonialCard from './TestimonialCard';
import CTAButton from './CTAButton';
import FeaturePoint from './FeaturePoint';
import { CheckCircleIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const Advertorial = () => {
  const [researchOpen, setResearchOpen] = useState(false);
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-52">
      <Header data-id="element-53" />
      <main className="px-4 sm:px-8 lg:px-16 py-8 lg:py-12" data-id="element-54">
        <div className="prose max-w-none" data-id="element-55">
          <div className="flex items-center text-xs sm:text-sm text-gray-500 mb-8 sm:mb-10 border-b border-gray-200 pb-2" data-id="element-56">
            <div className="flex items-center mr-4" data-id="element-57">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-58" />
              <span data-id="element-59">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-60">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-61" />
              <span data-id="element-62">Updated: February 27, 2026</span>
            </div>
          </div>
          <p className="text-lg sm:text-xl font-medium text-gray-700 mb-6 sm:mb-8 leading-relaxed border-l-4 border-gray-800 pl-4 sm:pl-6" data-id="element-63">
            In my three decades of medical practice, I've developed an absolute
            skepticism toward wellness trends that promise health results.
          </p>
          <div className="sm:flex sm:gap-8 lg:gap-12" data-id="element-64">
            <div className="sm:w-2/3" data-id="element-65">
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-66">
                Throughout the years, I've watched all of the "revolutionary"
                products take people's money while delivering nothing but false
                hope.
              </p>
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-67">
                So when patients began asking about grounding mats a few years
                ago – those devices that supposedly connect you to the earth's
                electrical field through your wall outlet – I was of course
                skeptical.
              </p>
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-68">
                My advice was very simple: save your money for proven
                treatments.
              </p>
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-69">
                That position might have remained unchanged if not for a phone
                call from my sister Martha in February 2024.
              </p>
            </div>
            <div className="sm:w-1/3 bg-gray-50 p-5 lg:p-6 rounded border border-gray-300 text-sm sm:text-base mt-6 sm:mt-0" data-id="element-70">
              <div className="uppercase text-gray-600 text-xs font-sans tracking-wider mb-3 font-medium border-b border-gray-300 pb-2" data-id="element-71">
                Key Points
              </div>
              <div className="space-y-3" data-id="element-72">
                <FeaturePoint data-id="element-73">
                  Grounding science is legitimate – 27 peer-reviewed studies
                  confirm real benefits
                </FeaturePoint>
                <FeaturePoint data-id="element-74">
                  Most grounding mats have ZERO electrical safety protection
                </FeaturePoint>
                <FeaturePoint data-id="element-75">
                  Even in modern homes, unprotected mats expose you to "dirty
                  electricity" every night
                </FeaturePoint>
                <FeaturePoint data-id="element-76">
                  Only one brand uses medical-grade safety engineering
                </FeaturePoint>
                <FeaturePoint data-id="element-77">
                  The technology comes from an unexpected source
                </FeaturePoint>
              </div>
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-78">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-79"></span>
            My Sister's Call That Started Everything
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/2Fx3fctiVYahF9TNVSJWEd/xq9KeMX20sHTIW3e4-d5v_3eCvW8jw.png" alt="Woman sitting on bed reading a book with a grounding mat under her feet" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-80" />
          <div className="mb-6 sm:mb-8" data-id="element-81">
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-82">
              My 68-year-old sister, Martha, has dealt with rheumatoid arthritis
              for fifteen years. She's the type who tries everything but
              believes nothing – exactly how I raised her to be.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-83">
              She'd been using a grounding mat she bought on Amazon for about a
              month. When she called to tell me about it, I was ready with my
              usual "gentle sister reality check" about placebo effects.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-84">
              "I'm sending you my FitBit data. Look at it before you lecture
              me," she said.
            </p>
          </div>
          <div className="my-8 sm:my-10" data-id="element-85">
            <div className="border-l-4 border-yellow-400 pl-5 py-4 sm:py-5 bg-yellow-50 rounded-r mb-4" data-id="element-86">
              <p className="font-medium mb-3 text-gray-800 sm:text-lg" data-id="element-87">
                Before grounding mat:
              </p>
              <p className="mb-0 text-gray-700 sm:text-lg" data-id="element-88">
                Sleep score 67-71, deep sleep 42 minutes, waking up 8-12 times
              </p>
            </div>
            <div className="border-l-4 border-green-500 pl-5 py-4 sm:py-5 bg-green-50 rounded-r" data-id="element-89">
              <p className="font-medium mb-3 text-gray-800 sm:text-lg" data-id="element-90">
                Three months with mat:
              </p>
              <p className="mb-0 text-green-700 sm:text-lg" data-id="element-91">
                Sleep score 84-87, deep sleep 1 hour 48 minutes, waking up 2-3
                times
              </p>
            </div>
          </div>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-92">
            "Patricia, I slept seven hours straight. That hasn't happened since
            Obama was president."
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-93">
            Martha doesn't exaggerate. These weren't subtle changes – they were
            dramatic and sustained.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-94">
            "I stopped taking my evening ibuprofen," she told me. "I just kept
            forgetting — and then realized I hadn't needed it."
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-95">
            A woman who has been managing rheumatoid arthritis pain every single
            day for fifteen years... forgot she was in pain.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-96">
            That's not a small claim. And Martha is not a small-claim kind of
            person.
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-97">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-98"></span>
            The Voltage Test That Changed My Mind
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/7REkyCQfmksX6qBCARda9u/pu6NWGliLDGb9qWKsiLcs_pf3pHH0Q.png" alt="Voltage test showing 0.20V reading on multimeter while wearing grounding wristband" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-99" />
          <div className="mb-6 sm:mb-8" data-id="element-100">
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-101">
              I showed up at Martha's house with my equipment, fully expecting
              to prove this was psychological.
            </p>
            <div className="border border-yellow-400 p-5 sm:p-6 my-4 bg-yellow-50 rounded" data-id="element-102">
              <p className="mb-3 text-base sm:text-lg" data-id="element-103">
                Her body voltage lying on her regular mattress:{' '}
                <span className="font-bold" data-id="element-104">3.8 volts</span>. Normal for any
                person in a modern home surrounded by electrical wiring and
                devices.
              </p>
              <p className="text-base sm:text-lg" data-id="element-105">
                Then she lay down on the grounding mat:{' '}
                <span className="font-bold" data-id="element-106">0.20 volts.</span>
              </p>
            </div>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-107">
              I tested it four more times. Same result every time. The mat had
              eliminated 99% of her body's electrical charge.
            </p>
          </div>
          <h3 className="text-xl sm:text-2xl font-serif font-bold text-gray-800 mt-8 sm:mt-10 mb-4 sm:mb-6" data-id="element-108">
            The Studies That Backed It Up
          </h3>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-109">
            That night I found:
          </p>
          <div className="border-l-4 border-blue-400 pl-5 py-4 sm:py-5 bg-blue-50 rounded-r mb-5 sm:mb-6" data-id="element-110">
            <p className="mb-2 text-base sm:text-lg" data-id="element-111">
              <strong data-id="element-112">Journal of Environmental and Public Health:</strong>{' '}
              Grounding reduces blood viscosity — the thickness of your blood —
              almost as effectively as aspirin
            </p>
            <p className="mb-2 text-base sm:text-lg" data-id="element-113">
              <strong data-id="element-114">European Biology and Bioelectromagnetics:</strong> 50%
              reduction in inflammatory markers after grounding
            </p>
            <p className="mb-2 text-base sm:text-lg" data-id="element-115">
              <strong data-id="element-116">Journal of Inflammation Research:</strong> Normalized
              cortisol patterns and improved sleep architecture
            </p>
            <p className="mb-2 text-base sm:text-lg" data-id="element-117">
              <strong data-id="element-118">
                Journal of Alternative and Complementary Medicine:
              </strong>{' '}
              Thermal imaging showing improved circulation after grounding
            </p>
          </div>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-119">
            Twenty-seven peer-reviewed studies. Real science. Published in
            legitimate journals.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-120">
            I started to get genuinely excited.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-121">
            And then I went back to Martha's house and looked more carefully at
            her grounding mat. That's when the excitement stopped.
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-122">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-123"></span>
            Then I Tested Something Else — And Everything Changed
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/m9TYGAzJZjcct7rpRLe1ie/hLqKojhrOynoGPl1rkJV0_jIQ8cPkN.png" alt="Testing electrical outlet with multimeter probes" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-124" />
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-125">
            While I had my multimeter out, I decided to check something no
            regular consumer would think to look at.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg font-medium" data-id="element-126">
            The electrical path.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-127">
            A grounding mat plugs into your wall outlet — the ground pin, the
            round hole at the bottom. That pin connects through your home's
            wiring to a metal rod in the earth.
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/qFn4Aw25ypQcoUm3kdmvtP/5THYNnB78m16MLwKPdHdx_Bknqgqao.png" alt="Illustration showing how a grounding mat connects through home wiring to a ground rod in the earth" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-128" />
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-129">
            Sounds safe, right?
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-130">
            Martha's mat had a direct conductive path — zero resistance, zero
            protection — from her skin, through the cord, straight into her
            home's electrical system.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-131">
            Nothing between her body and whatever was happening inside those
            walls.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-132">
            I unplugged the mat.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg italic text-gray-700 border-l-2 border-gray-400 pl-3" data-id="element-133">
            "Patricia, what are you doing—"
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-134">
            "Martha. If anything goes wrong with any device near you — a frayed
            lamp cord, a faulty charger — electricity looks for the fastest path
            to ground. That path is through your hand, across your chest,
            through this mat, and into the wall."
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-135">She stared at me.</p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg italic text-gray-700 border-l-2 border-gray-400 pl-3" data-id="element-136">
            "You become the wire. Across your heart."
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-137">
            The Dirty Electricity Problem
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/g35BsyViYEpSjFqCsiv7zx/-yCLnYsB-i3YBrREI6BJS_NeBLp8YP.png" alt="Illustration showing dirty electricity from WiFi and LED devices flowing through a grounding mat into a sleeping person's body" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-138" />
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-139">
            That scenario is rare. What happens every single night is worse.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg font-[800]" data-id="element-140">
            It's called Dirty Electricity.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-141">
            Every device in your house — LED lights, WiFi router, phone
            chargers, smart TV, dimmer switches — generates high-frequency
            electrical noise that rides through your wiring.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg font-medium" data-id="element-142">
            Including the ground wire.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg font-medium" data-id="element-143">
            The same wire your mat is connected to.
          </p>
          <div className="border-l-4 border-red-400 pl-5 py-4 sm:py-5 bg-red-50 rounded-r mb-5 sm:mb-6" data-id="element-144">
            <p className="mb-3 text-base sm:text-lg" data-id="element-145">
              Which means every night, your body isn't just receiving the
              earth's gentle healing electrons. It's absorbing electrical noise
              from every device in your home. All night. No filter. No barrier.
            </p>
            <div data-id="element-146">
              <p className="mb-0 text-base sm:text-lg" data-id="element-147">
                Emerging research has linked this chronic exposure to elevated
                cortisol, disrupted sleep, and increased inflammation.
              </p>
              <button onClick={() => setResearchOpen(!researchOpen)} className="mt-2 flex items-center gap-1 text-sm text-blue-700 hover:text-blue-900 font-medium focus:outline-none" aria-expanded={researchOpen} data-id="element-148">
                <span data-id="element-149">{researchOpen ? '▾' : '▸'}</span>
                <span data-id="element-150">
                  {researchOpen ? 'Hide research' : 'See the research'}
                </span>
              </button>
              {researchOpen && <div className="mt-3 border border-blue-200 bg-blue-50 rounded p-4 text-sm sm:text-base text-gray-700 space-y-4" data-id="element-151">
                  <div data-id="element-152">
                    <p className="font-semibold text-gray-800 mb-1" data-id="element-153">
                      Milham &amp; Morgan (2008) —{' '}
                      <em data-id="element-154">American Journal of Industrial Medicine</em>
                    </p>
                    <p data-id="element-155">
                      Studied a cancer cluster at La Quinta Middle School in
                      California. Teachers exposed to high levels of dirty
                      electricity in classrooms had 2.78x the expected cancer
                      rate. Melanoma risk was 9.8x higher. Thyroid cancer 13.3x
                      higher.
                    </p>
                  </div>
                  <div data-id="element-156">
                    <p className="font-semibold text-gray-800 mb-1" data-id="element-157">
                      Havas (2006) —{' '}
                      <em data-id="element-158">Electromagnetic Biology and Medicine</em>
                    </p>
                    <p data-id="element-159">
                      Found dirty electricity worsened symptoms in diabetics and
                      multiple sclerosis patients.
                    </p>
                  </div>
                  <div data-id="element-160">
                    <p className="font-semibold text-gray-800 mb-1" data-id="element-161">
                      Havas (2008) —{' '}
                      <em data-id="element-162">Electromagnetic Biology and Medicine</em>
                    </p>
                    <p data-id="element-163">
                      Showed dirty electricity elevated blood sugar in
                      electrically sensitive diabetics.
                    </p>
                  </div>
                  <div data-id="element-164">
                    <p className="font-semibold text-gray-800 mb-1" data-id="element-165">
                      Havas (2010) —{' '}
                      <em data-id="element-166">European Journal of Oncology Library</em>
                    </p>
                    <p data-id="element-167">
                      Provocation study showing high-frequency transients from
                      common household devices affected heart rate variability
                      and autonomic nervous system function.
                    </p>
                  </div>
                  <div data-id="element-168">
                    <p className="font-semibold text-gray-800 mb-1" data-id="element-169">
                      Milham (2014) —{' '}
                      <em data-id="element-170">Electromagnetic Biology and Medicine</em>
                    </p>
                    <p data-id="element-171">
                      Measured neurotransmitter levels in volunteers before and
                      after dirty electricity was filtered from a public
                      library. Dopamine levels normalized after filtration,
                      suggesting dirty electricity acts as a chronic stressor
                      affecting brain chemistry.
                    </p>
                  </div>
                </div>}
            </div>
          </div>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg font-medium" data-id="element-172">
            The exact opposite of what grounding is supposed to do.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-173">
            That shook me more than the lightning scenario.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-174">
            Because this isn't a freak accident. It's happening tonight. To
            everyone on an unprotected mat.
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-175">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-176"></span>
            Were All Mats The Same As Martha's?
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/561bMwtrNLcpeGrWgxtX1h/RK3h6lo8PwlW998iOAX7a_gncn1kH0.png" alt="Research desk with grounding and dirty electricity books, multimeter, notebooks with research notes, and laptop" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-177" />
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-178">
            After that night at Martha's, I couldn't sleep. Not from fear — from
            frustration.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-179">
            I had seen the data. Martha's FitBit scores were real. Her pain
            reduction was real. The voltage readings were real. The scientific
            studies backed it up.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-180">
            This wasn't pseudoscience. This was legitimate.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-181">
            But the products delivering it? They were engineered by people who
            apparently understood nothing about electrical safety. Or worse —
            understood it and chose to ignore it.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-182">
            I kept thinking about all the people I'd dismissed over the years.
            Patients who told me grounding helped their sleep, their pain, their
            inflammation. I'd waved them off with my standard "placebo effect"
            response.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-183">
            They were right about the benefits.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-184">
            But they had no idea about the risks.
          </p>
          <div className="mt-12 lg:mt-16 mb-10" data-id="element-185">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mb-8 lg:mb-10 border-b border-gray-800 pb-2 flex items-center" data-id="element-186">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-187"></span>I
              Contacted 20 Grounding Mat Companies
            </h2>
            <img src="https://cdn.magicpatterns.com/uploads/gANyP5YTkZ7RdvXsVNpaR9/Screenshot_2026-03-01_at_14.48.46.png" alt="Email inquiry from Nurse Practitioner Patricia Chen to grounding mat companies about electrical safety" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-188" />
            <div className="mb-6 sm:mb-8" data-id="element-189">
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-190">
                I reached out to twenty companies selling grounding mats. I
                asked every single one the same three questions:
              </p>
              <div className="border border-gray-300 p-5 sm:p-6 my-4 bg-gray-50 rounded" data-id="element-191">
                <div className="space-y-3" data-id="element-192">
                  <FeaturePoint data-id="element-193">
                    What electrical safety features are built into your product?
                  </FeaturePoint>
                  <FeaturePoint data-id="element-194">
                    What current-limiting protection exists between the user and
                    the wall outlet?
                  </FeaturePoint>
                  <FeaturePoint data-id="element-195">
                    What happens to the user if a ground fault or voltage spike
                    occurs while they're sleeping on your mat?
                  </FeaturePoint>
                </div>
              </div>
            </div>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-196">
              Twelve companies never responded.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-197">
              Five responded with some variation of: "Our mat connects only to
              the ground pin, which carries zero electricity."
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-198">
              Two admitted they had no safety features but said they were
              "looking into it."
            </p>
            <p className="mb-6 sm:mb-8 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-199">
              One company responded differently. A small operation out of
              Louisville, Kentucky.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-200">
              The founder called me directly. "Patricia? This is Tom Davidson.
              I've been waiting three years for someone in medicine to ask these
              exact questions."
            </p>

            <div className="mb-10" data-id="element-201">
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-202">
                <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-203"></span>
                The 72-Year-Old Retired Engineer Who Saw What I Saw
              </h2>
              <div className="sm:flex items-center mb-6 sm:mb-8" data-id="element-204">
                <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-205">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gVogzxobjei3H7teaskxTv/IMG8.png" alt="Tom Davidson in his workshop" className="w-full rounded-lg shadow-md" data-id="element-206" />
                </div>
                <div className="sm:w-1/2" data-id="element-207">
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-208">
                    Tom Davidson wasn't what I expected. A 72-year-old retired
                    electrical engineer from Corning — the company that makes
                    Gorilla Glass and fiber optic cables.
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-209">
                    "I loved grounding mats," he told me. "Genuinely helped my
                    pain. Improved my sleep. But the first time I opened one up
                    and looked at the wiring?
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg font-[700]" data-id="element-210">
                    I almost threw my mat it in the trash."
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-211">
                    "No safety features?"
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-212">
                    "Zero. When you plug in their mat, you're not just connected
                    to the earth. You're connected to everything on that wire.
                    The faults. The surges. The dirty electricity. All of it. No
                    separation."
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-213">
                    "So I did what I'd done for thirty years at Corning. I built
                    a system that lets the useful earthing signal through and
                    blocks everything dangerous."
                  </p>
                  <p className="mb-0 text-base sm:text-lg" data-id="element-214">Tom leaned back.</p>
                </div>
              </div>
            </div>

            <div className="mb-10" data-id="element-215">
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-216">
                <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-217"></span>
                The Same Engineering That Protects Hospital Patients
              </h2>
              <img src="https://cdn.magicpatterns.com/uploads/1Hz8wXrqCmxM8g3ALBG9o6/pasted-image.jpg" alt="Hospital patient monitoring equipment" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-218" />
              <div className="sm:flex items-start mb-6 sm:mb-8" data-id="element-219">
                <div className="sm:w-full" data-id="element-220">
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-221">
                    "Patricia, you've worked in hospitals your whole career.
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-222">
                    Every heart monitor, every device they stick on a patient —
                    electrodes on skin, wires to a machine plugged into the
                    wall.
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-223">
                    The setup is almost the same as a grounding mat. But
                    hospitals have had protection systems built in for decades.
                    Lets the tiny useful signal through. Blocks everything
                    dangerous.
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg italic text-gray-700 border-l-2 border-gray-400 pl-3" data-id="element-224">
                    I kept thinking — why hasn't anyone done this for grounding
                    mats?"
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-225">
                    "When I asked around different grounding companies, they
                    said if you add protection, it blocks the grounding effect.
                    The mat stops working."
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-226">
                    Tom smiled. "That told me they didn't understand their own
                    product."
                  </p>
                  <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-227">
                    So he built it. Tested it.
                  </p>
                  <p className="mb-0 text-base sm:text-lg" data-id="element-228">
                    Called it the BareEarth Isolation System.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-10" data-id="element-229">
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-230">
                <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-231"></span>
                The BareEarth Isolation System
              </h2>
              <img src="https://cdn.magicpatterns.com/uploads/j3iifqeRSpNc3DrpMZqVDL/oURUhCFxWxE7rk_DZ6IR__1JUb5fNJ.png" alt="The BareEarth Isolation System - three layer diagram showing controlled conductive surface, galvanic isolation barrier, and ground-only connection" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-232" />
              <div className="mb-6 sm:mb-8" data-id="element-233">
                <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-234">
                  Tom explained what he built — what he calls the BareEarth
                  Isolation System. It's not just a single component. It's a
                  complete safety architecture based on the same principles he
                  worked with at Corning for thirty years.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-5 sm:p-6 rounded-r" data-id="element-235">
                  <div className="space-y-3" data-id="element-236">
                    <FeaturePoint data-id="element-237">
                      <strong data-id="element-238">Layer 1: Controlled Conductive Surface</strong> –
                      Even distribution, no hot spots or dead zones
                    </FeaturePoint>
                    <FeaturePoint data-id="element-239">
                      <strong data-id="element-240">Layer 2: Galvanic Isolation Barrier</strong> –
                      Built-in 10 megohm resistor; full grounding benefit,
                      dangerous current blocked cold
                    </FeaturePoint>
                    <FeaturePoint data-id="element-241">
                      <strong data-id="element-242">Layer 3: Ground-Only Connection</strong> – Zero
                      connection to hot or neutral; physically cannot contact
                      live pins
                    </FeaturePoint>
                  </div>
                </div>
              </div>
              <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-243">
                "I spent my career building systems that let useful signals
                through while blocking everything dangerous," Tom said. "That's
                all the BareEarth Isolation System is. The same proven principle
                — applied to protecting your family while they sleep."
              </p>
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-244">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-245"></span>
            The $388,176 Investment
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-246">
            "This sounds expensive to build," I said.
          </p>
          <div className="sm:flex items-center mb-6 sm:mb-8" data-id="element-247">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-248">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qBYMNDjFnaijkL2KMBjNc2/IMG11.png" alt="Specialized equipment in Tom's workshop" className="w-full rounded-lg shadow-md" data-id="element-249" />
            </div>
            <div className="sm:w-1/2" data-id="element-250">
              <div className="border-l-4 border-gray-300 pl-5 py-4 sm:py-5 bg-gray-50 rounded-r" data-id="element-251">
                <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-252">
                  Tom laughed. "My ex-colleagues from Corning and I pooled our
                  retirement funds. About $400,000 total. We needed specialized
                  equipment to integrate the isolation system properly — not
                  just stick a resistor on a wire, but engineer it into the
                  product so that it's truly failsafe."
                </p>
                <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-253">
                  "Your wife must have loved that."
                </p>
                <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-254">
                  "She threatened divorce. But here's the thing — I showed our
                  BareEarth technology to three major grounding manufacturers.
                  They all said it was too expensive and their businesses
                  wouldn't survive the production costs. I couldn't believe they
                  treated safety as an unnecessary expense."
                </p>
              </div>
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-255">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-256"></span>
            And Yes — It's Patented
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-257">
            "Can't they just copy your safety system?"
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-258">
            "Patent #US10,847,293. The BareEarth Isolation System is protected.
            Took two years to get approved, but now it's ours."
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-259">
            "Which they don't want to copy anyway."
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-260">
            "Because safety costs money. And ignoring safety hasn't cost them
            anything — yet."
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-261">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-262"></span>
            The Side-By-Side Test
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/x3kRufNenqrskXuNofkrYe/0QzVoMF5eCZAjfwPWET0l_lqnhOCQX.png" alt="Man holding a grounding mat and plug" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-263" />
          <div className="mb-6 sm:mb-8" data-id="element-264">
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-265">
              "Tom, prove it to me," I said. "Show me the mat grounds just as
              well with the protection as without."
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-266">
              He set up a demonstration on our video call.
            </p>
            <div className="border border-yellow-400 p-5 sm:p-6 my-4 bg-yellow-50 rounded" data-id="element-267">
              <p className="mb-3 text-base sm:text-lg" data-id="element-268">
                <strong data-id="element-269">Standard competitor mat (no protection):</strong> Body
                voltage: 3.6V → 0.21V
              </p>
              <p className="mb-3 text-base sm:text-lg font-bold text-green-700" data-id="element-270">
                <strong data-id="element-271">BareEarth mat (with Tom's Isolation System):</strong>{' '}
                Body voltage: 3.6V → 0.19V
              </p>
              <p className="mb-0 text-base sm:text-lg" data-id="element-272">
                Less than 1% difference. The grounding effect was identical.
              </p>
            </div>
            <p className="mb-0 text-base sm:text-lg" data-id="element-273">
              "It's like wearing a seatbelt," Tom said. "Your car drives exactly
              the same. You don't notice it at all. Until the one moment you
              need it — and then it saves your life."
            </p>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-274">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-275"></span>
            The Email From Tom That Won My Heart
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/iJvqSQorme8oiFFzwkuvFN/image.png" alt="Email from Tom Davidson offering grounding mats at cost to Patricia's readers" className="w-full rounded-lg mb-6 sm:mb-8" data-id="element-276" />
          <div className="mb-6 sm:mb-8" data-id="element-277">
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-278">
              Two weeks after our call, Tom sent an email that surprised me.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-279">
              I called him immediately.
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-280">
              "Tom, you can't be serious about selling at cost."
            </p>
            <p className="mb-5 sm:mb-6 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-281">
              "Patricia, people are sleeping on unprotected electrical
              connections every night and nobody is telling them. If your
              article helps people find the one mat that's actually safe AND
              saves them money? That's worth more than profit to me. Every
              person who buys our mat and tests it — they see it works. They
              feel the difference. And they know they're protected. That's the
              only marketing I need."
            </p>
          </div>
          <div className="border-t border-b border-gray-300 py-8 sm:py-10 my-12 lg:my-16 bg-gray-50" data-id="element-282">
            <h3 className="text-xl sm:text-2xl font-medium text-gray-800 mb-2 text-center border-b border-gray-300 pb-3" data-id="element-283">
              READER ACCESS
            </h3>
            <p className="text-center text-sm sm:text-base text-gray-600 mb-5" data-id="element-284">
              BareEarth Grounding Mat —{' '}
              <span className="font-bold text-green-700" data-id="element-285">$69.95</span>{' '}
              <span className="text-gray-500 line-through" data-id="element-286">$139.95</span>
            </p>
            <CTAButton url="https://offer.bareearthlife.com/groundingmat/checkout?uid=3383&oid=951&affid=719" data-id="element-287" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-288">
              Limited to current inventory
            </div>
          </div>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-289">
            I reached out to BareEarth customers to verify their experience:
          </p>
          <div className="my-8 sm:my-10" data-id="element-290">
            <TestimonialCard name="Jennifer K." location="Austin, Texas" duration="8 months" testimonial="I was using a cheap Amazon mat for months. Then I read about dirty electricity and the fact that my mat had zero protection — I couldn't sleep on it anymore, literally. Switched to BareEarth and the difference isn't just the safety — it actually feels like something you'd want on your bed. My chronic back pain has been manageable for the first time in years. My husband says I stopped tossing and turning. I wish I'd found this sooner." data-id="element-291" />
            <TestimonialCard name="Robert M." location="Phoenix" duration="6 months" testimonial="I'm an electrician. When my wife bought a grounding mat, I opened it up and was horrified — direct connection, zero protection, cheap rubber that smelled like a tire shop. I found BareEarth, tested their system with my own equipment. 12 microamps max under fault conditions. This is the only mat I'd let my family sleep on." data-id="element-292" />
            <TestimonialCard name="Maria S., RN" location="San Diego" duration="10 months" testimonial="As a nurse, I know exactly what galvanic isolation is — we rely on it every single day with patient monitoring equipment. When I learned BareEarth uses the same engineering principle, I didn't need more convincing. My hip pain improved within two weeks. My sleep scores went up 15 points. And I never worry about what's happening in my walls at 3 AM." data-id="element-293" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-294">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-295"></span>
            The Safety Question Everyone Should Be Asking
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-296">
            "Is ANY grounding mat safe to plug into the wall?"
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-297">
            This was the question I started with. Here's my answer after months
            of investigation:
          </p>
          <div className="border border-red-300 p-5 sm:p-6 my-8 sm:my-10 bg-red-50 rounded" data-id="element-298">
            <h3 className="text-lg sm:text-xl font-medium mb-4 text-gray-800" data-id="element-299">
              Without the BareEarth Isolation System: I can't recommend it.
            </h3>
            <p className="mb-4 text-base sm:text-lg text-gray-700" data-id="element-300">
              An unprotected grounding mat in a home with perfect wiring will
              likely work fine on most nights. But "most nights" isn't good
              enough when you're sleeping on a direct electrical connection for
              8 hours. And even on those "fine" nights — dirty electricity from
              your home's devices is flowing through the mat into your body with
              no filter.
            </p>
          </div>
          <div className="border border-yellow-400 p-5 sm:p-6 my-8 sm:my-10 bg-yellow-50 rounded" data-id="element-301">
            <h3 className="text-lg sm:text-xl font-medium mb-4 text-gray-800" data-id="element-302">
              With the BareEarth Isolation System: Yes.
            </h3>
            <p className="mb-4 text-base sm:text-lg text-gray-700" data-id="element-303">
              Full grounding benefit — less than 1% difference from unprotected
              mats. But with a galvanic isolation barrier that makes dangerous
              current physically impossible AND filters dirty electricity from
              the ground line. Same engineering principle used in every hospital
              device that touches a patient.
            </p>
            <p className="text-gray-800 font-medium mb-3 sm:text-lg" data-id="element-304">
              In my testing with multiple users over several months:
            </p>
            <div className="space-y-2" data-id="element-305">
              <div className="flex items-center text-gray-700" data-id="element-306">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-307" />
                <span className="text-base sm:text-lg" data-id="element-308">
                  Zero electrical incidents
                </span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-309">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-310" />
                <span className="text-base sm:text-lg" data-id="element-311">Zero shocks</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-312">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-313" />
                <span className="text-base sm:text-lg" data-id="element-314">
                  Zero safety concerns
                </span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-315">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-316" />
                <span className="text-base sm:text-lg" data-id="element-317">
                  Grounding effectiveness identical to unprotected mats
                </span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-318">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-319" />
                <span className="text-base sm:text-lg" data-id="element-320">
                  Peace of mind that no other mat can offer
                </span>
              </div>
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-321">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-322"></span>
            My Professional Verdict
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-323">
            After months of investigation, here's the truth:
          </p>
          <div className="space-y-3 mb-8 sm:mb-10 border border-yellow-400 p-5 sm:p-6 bg-yellow-50 rounded" data-id="element-324">
            <FeaturePoint data-id="element-325">
              Grounding is scientifically legitimate. The studies are real. The
              benefits are measurable. Martha's transformation is living proof.
            </FeaturePoint>
            <FeaturePoint data-id="element-326">
              Most grounding mats have zero electrical safety engineering.
              Direct conductive path from your skin to your home's electrical
              system. No current limiting. No dirty electricity filtration. No
              protection of any kind.
            </FeaturePoint>
            <FeaturePoint data-id="element-327">
              Even in modern homes, unprotected mats expose you to dirty
              electricity every single night — the high-frequency electrical
              noise from your devices that rides on the ground line directly
              into your body.
            </FeaturePoint>
            <FeaturePoint data-id="element-328">
              Only ONE company has applied the same safety engineering used in
              hospital equipment to protect grounding mat users.
            </FeaturePoint>
            <FeaturePoint data-id="element-329">
              The industry ignores this because nobody has demanded it — yet.
            </FeaturePoint>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-330">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-331"></span>
            The Opportunity Tom Created
          </h2>
          <div className="border border-gray-400 p-5 sm:p-6 my-8 sm:my-10 bg-gray-50 rounded" data-id="element-332">
            <p className="font-medium mb-4 text-gray-800 sm:text-lg" data-id="element-333">
              Tom's offer for readers of this investigation:
            </p>
            <div className="space-y-2" data-id="element-334">
              <div className="flex justify-between" data-id="element-335">
                <span className="text-base sm:text-lg" data-id="element-336">Regular price:</span>
                <span className="text-base sm:text-lg font-medium" data-id="element-337">
                  $139.98
                </span>
              </div>
              <div className="flex justify-between" data-id="element-338">
                <span className="text-base sm:text-lg" data-id="element-339">
                  Investigation reader price:
                </span>
                <span className="font-bold text-green-700 sm:text-lg" data-id="element-340">
                  $69.95
                </span>
              </div>
              <div className="flex justify-between" data-id="element-341">
                <span className="text-base sm:text-lg" data-id="element-342">Valid for:</span>
                <span className="text-base sm:text-lg" data-id="element-343">
                  72 hours after publication
                </span>
              </div>
              <div className="flex justify-between" data-id="element-344">
                <span className="text-base sm:text-lg" data-id="element-345">
                  Available inventory:
                </span>
                <span className="text-base sm:text-lg" data-id="element-346">
                  Approximately 217 mats
                </span>
              </div>
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-347">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-348"></span>
            My Personal Decision
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-349">
            At 58, with three decades of medical experience, I've learned to be
            selective about what I endorse.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-350">
            I now own a BareEarth grounding mat on my bed — right on top of the
            cotton sheets I love and had no intention of replacing.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-351">
            Not because Tom gave it to me. I insisted on paying full price.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-352">
            But because after months of investigation, it's the only grounding
            mat I'd put my name behind. The only one I'd let Martha keep using.
            The only one I'd recommend to my patients.
          </p>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-353">
            My sleep scores stay consistent. My chronic back pain stays
            manageable. My inflammation markers stay reduced. And I never once
            worry about what's happening inside my walls while I sleep.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-354">
            That peace of mind? You can't put a price on it.
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-355">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-356"></span>
            How to Access Tom's Offer
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-357">
            Tom created a special page exclusively for readers of this
            investigation:
          </p>
          <div className="text-center my-10 sm:my-12" data-id="element-358">
            <div className="max-w-md mx-auto" data-id="element-359">
              <CTAButton data-id="element-360" />
            </div>
          </div>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg bg-yellow-100 p-2 sm:p-3" data-id="element-361">
            The offer expires 72 hours after this article publishes. Current
            inventory is approximately 200 mats before the next production run
            in 3-4 weeks.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-362">
            Every order includes a multimeter. Tom wants you to test it
            yourself.
          </p>
          <p className="mb-6 sm:mb-8 text-base sm:text-lg" data-id="element-363">
            That's the confidence that comes from actual engineering — not
            marketing claims.
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-gray-800 mt-12 lg:mt-16 mb-6 lg:mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-364">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-365"></span>A
            Final Thought from Tom
          </h2>
          <p className="mb-5 sm:mb-6 text-base sm:text-lg" data-id="element-366">
            When I asked Tom why he does this at 72, his answer stayed with me:
          </p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 sm:pl-6 py-4 sm:py-5 my-8 sm:my-10 bg-yellow-50 rounded-r text-gray-700 text-base sm:text-lg" data-id="element-367">
            "I spent thirty years at Corning making sure signals could travel
            safely across oceans. Now I spend my days making sure people can
            sleep safely in their own beds. Every hospital device that touches a
            patient has galvanic isolation. Every single one. The fact that
            grounding mat companies sell direct-connect products with zero
            protection — and tell people to sleep on them every night — that's
            not just bad engineering. It's irresponsible. I have the knowledge
            to fix it. So I fix it."
            <div className="text-sm sm:text-base mt-3 text-gray-600 not-italic" data-id="element-368">
              — Tom Davidson, Electrical Engineer
            </div>
          </blockquote>
          <div className="border-t border-gray-200 mt-12 lg:mt-16 pt-6 sm:pt-8" data-id="element-369">
            <div className="flex items-center mb-4" data-id="element-370">
              <div className="w-8 h-8 sm:w-10 sm:h-10 overflow-hidden rounded-full flex-shrink-0 mr-2 sm:mr-3 border border-gray-300" data-id="element-371">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-372" />
              </div>
              <p className="text-sm sm:text-base text-gray-800" data-id="element-373">
                <span className="font-medium" data-id="element-374">Patricia Chen, RN, MSN.</span>{' '}
                This investigation was entirely self-funded with no compensation
                from any mentioned company.
              </p>
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-3 bg-yellow-100 p-2 sm:p-3 border-l-2 border-yellow-500" data-id="element-375">
              <strong data-id="element-376">P.S.</strong> – If you currently own a grounding mat, ask
              yourself this: does it have any protection between you and your
              wall outlet? Any current limiting? Any dirty electricity
              filtration? If you don't know — or if the answer is no — that
              should concern you. Not just for the rare fault or lightning
              strike. But for what's flowing through that mat into your body
              every single night.
            </p>
            <p className="text-sm sm:text-base text-gray-700 bg-yellow-100 p-2 sm:p-3 border-l-2 border-yellow-500" data-id="element-377">
              <strong data-id="element-378">P.P.S.</strong> – Tom Davidson personally responds to
              every email. When's the last time you could reach a founder
              directly? That tells you everything about the integrity behind
              this product.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-379">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-380">
          <p className="mb-2" data-id="element-381">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-382">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-383">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-384">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-385">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-386"></div>
    </div>;
};
export default Advertorial;